import { useContext } from 'react';
import Spinner from '../shared/Spinner';
import ReposItem from './ReposItem';
import GithubContext from '../../context/github/GithubContext';


function ReposList() {
    const { loading, repos } = useContext(GithubContext);

    if(!loading) {
        return (
        <div className="rounded-lg shadow-lg card bg-base-100">
            <div className="card-body">
                    <h2 className="text-3xl my-4 font-bold card-title">
                    Latest Repositories
                    </h2>
                    {repos.map((repo) => (
                        <ReposItem key={repo.id} repo={repo}/>
                    ))}
            </div>
        </div>
        )
    } else {
        return <Spinner />
    }
}


export default ReposList
